/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint-disable-next-line max-len */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state", "payload"] }] */

import api from '../../utils/api';

const state = {
  loading: false,
  comingSoonAccess: false,
  submissionsAccess: false,
  token: sessionStorage.getItem('mh-token') || '',
};

const getters = {
  // isAuthenticated: state => !!state.token
  isAuthenticated(state) {
    if (state.loading === false) {
      return !!state.token;
    }
    return false;
  },
  hasComingSoonAccess(state) {
    return state.comingSoonAccess;
  },
  hasSubmissionsAccess(state, getters) {
    if (getters.isAuthenticated) return true;
    if (state.submissionsAccess) return true;
    return false;
  },
};

const mutations = {
  setLoading(state, { loading }) {
    state.loading = loading;
  },
  setComingSoonAccess(state, { access }) {
    state.comingSoonAccess = access;
  },
  setSubmissionsAccess(state, { access }) {
    state.submissionsAccess = access;
  },
  setToken(state, token) {
    if (token !== null) {
      sessionStorage.setItem('mh-token', token);
    } else {
      sessionStorage.removeItem('mh-token');
    }
    state.token = token;
  },
};

const actions = {
  grantComingSoonAccess({ commit }) {
    return new Promise((resolve) => {
      commit('setComingSoonAccess', { access: true });
      resolve();
    });
  },
  grantSubmissionsAccess({ commit }) {
    return new Promise((resolve) => {
      commit('setSubmissionsAccess', { access: true });
      resolve();
    });
  },
  login({ commit, dispatch }, { email, password }) {
    commit('setLoading', { loading: true });
    return new Promise((resolve, reject) => {
      // SEND CREDENTIALS TO SERVER, GET TOKEN
      api
        .login(email, password)
        .then((res) => {
          if (res.data.message) {
            const { message } = res.data;
            commit('setLoading', { loading: false });
            reject(message);
          } else {
            const { token } = res.data;
            const { publicId } = res.data;
            // set token in sessionStorage, state
            commit('setToken', token);
            // get customer account data
            dispatch('user/getUser', publicId, { root: true });
            commit('setLoading', { loading: false });
            resolve(res);
          }
        })
        .catch((error) => {
          // if request fails, purge any possible token
          commit('setToken', null);
          sessionStorage.removeItem('mh-token');
          reject(error);
        });
    });
  },
  logout({ commit, dispatch }) {
    commit('setLoading', { loading: true });
    commit('setToken', null);
    dispatch('user/clearUser', {}, { root: true });
    dispatch('user/clearCard', {}, { root: true });
    commit('setLoading', { loading: false });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
